export default __webpack_public_path__ + "static/media/github.e0d7d725.svg";